function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22",
  height: "14",
  viewBox: "0 0 22 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "7",
  cy: "7",
  r: "6",
  stroke: "#12002D",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.842 7.316C9.842 8.71 8.57 9.842 7 9.842S4.158 8.711 4.158 7.316M20.35 2.275H15.8",
  stroke: "#12002D",
  strokeWidth: "1.5",
  strokeLinecap: "round"
})));